import React, { Component } from 'react';
import styled from 'styled-components';
import {
  Input,
  Button,
  DateComponent,
  Dropdown,
  IncrementDecrement,
} from '@trp-rps-rps-shared-web/rps-shared-web-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { connect } from 'react-redux';
import { accountActions, modalActions, spouseActions, chartsActions } from '../../../redux/root-action';
import ReactModalFooter from '../../Modal/ReactModalFooter';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import ReactModalContent from '../../Modal/ReactModalContent';
import { modals, accountModalViews, genderOptions, postActions, analyticsTracking } from '../../../utils/constants';
import {
  getDateString,
  formatAmountWithoutDollarAndDecimals,
  isNumeric,
  isWithinAllowedRange,
  isValidBirthDate,
  isValidName,
  getIntegerAmount,
  getCurrentYear,
  getAge,
  keyDown,
} from '../../../utils/helpers';
import { isInternal } from '../../../utils/api';
import { getParticipantAge } from 'selectors';

const StyledFieldContainer = styled.div`
  display: flex;
  width: 100%;
  @media only screen and (max-width: 767px) {
    margin-top: 16px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
`;

const StyledInputLabel = styled.div`
  height: 56px;
  width: 120px;
  margin-right: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media only screen and (max-width: 767px) {
    height: auto;
    width: auto;
  }
`;

const StyledIntroLine = styled.div`
  font-size: 20px;
  margin-top: 32px;
  @media only screen and (max-width: 767px) {
    font-size: 16px;
    margin-top: 24px;
  }
`;

const StyledText = styled.div`
  font-family: Nimbus Sans Bold;
  margin: 32px 0px 32px 0px;
  @media only screen and (max-width: 767px) {
    margin: 32px 0px 32px 0px;
  }
`;

const StyledDropdownMessage = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 14px;
  line-height: 18px;
  color: ${tokens.ColorGrey600};
  margin-bottom: 20px;
`;

const StyledSocialSecurity = styled.div`
  margin-top: -8px;
  @media only screen and (max-width: 767px) {
    margin-top: 16px;
  }
`;

const StyledError = styled.div`
  font-size: 14px;
  font-family: Nimbus Sans Regular;
  color: ${tokens.ColorFunctionalRed700};
  width: 100%;
  margin-bottom: 8px;
`;

const StyledInputErrorContainer = styled.div`
  width: auto;
  @media only screen and (max-width: 767px) {
    width: 100%;
  }
`;

class AddSpouseProfile extends Component<any, any> {
  handleNameChange = (event: any) => {
    const { updateSpouseData } = this.props;
    const value = event.target.value;

    if (!isValidName(value) || value.length > 35) {
      return;
    }

    updateSpouseData({
      [event.target.name]: value,
    });
  };

  handleSalaryChange = (event: any) => {
    const { updateSpouseData } = this.props;
    if (!isNumeric(getIntegerAmount(event.target.value))) {
      return;
    }

    updateSpouseData({
      [event.target.name]: getIntegerAmount(event.target.value),
    });
  };

  handleRetirementAgeChange = (event: any) => {
    if (!isNumeric(event.target.value) || event.target.length > 3) {
      return;
    }
    const { updateSpouseData } = this.props;

    updateSpouseData({
      [event.target.name]: Number(event.target.value),
    });
  };

  incrementSocialSecurityAge = () => {
    const {
      updateSpouseData,
      spouse: {
        tempScenario: { spouseSocialSecurityStartAge },
      },
    } = this.props;
    updateSpouseData({
      spouseSocialSecurityStartAge: spouseSocialSecurityStartAge + 1,
    });
  };

  decrementSocialSecurityAge = () => {
    const {
      updateSpouseData,
      spouse: {
        tempScenario: { spouseSocialSecurityStartAge },
      },
    } = this.props;
    updateSpouseData({
      spouseSocialSecurityStartAge: spouseSocialSecurityStartAge - 1,
    });
  };

  handleDateChange = (event: any) => {
    if (!isNumeric(event.target.value)) {
      return;
    }
    const {
      spouse: {
        tempScenario: { birthDateObj },
      },
      updateSpouseData,
    } = this.props;

    const updatedBirthDateObj = {
      ...birthDateObj,
      [event.target.name]: event.target.value ? parseInt(event.target.value) : '',
    };

    updateSpouseData({
      birthDateObj: updatedBirthDateObj,
    });
  };

  handleGenderOptionChange = (option: any) => {
    const { updateSpouseData, updateSpouseError } = this.props;
    updateSpouseData({
      gender: option.value,
    });
    updateSpouseError({ showGenderMessage: option.value === 'P' ? true : false });
  };

  isDataValid = () => {
    const {
      spouse: {
        tempScenario: {
          firstName,
          lastName,
          gender,
          currentSalary,
          spouseRetirementStartAge,
          spouseRetirementEndAge,
          retirementEndAge,
          birthDateObj,
        },
      },
      participantAge,
      updateSpouseError,
    } = this.props;
    let showGlobalError = false,
      firstNameError,
      lastNameError,
      genderError,
      birthDateError,
      currentSalaryError,
      spouseRetirementStartAgeError;

    if (!firstName) {
      firstNameError = 'This field is required.';
      showGlobalError = true;
    }
    if (!lastName) {
      lastNameError = 'This field is required.';
      showGlobalError = true;
    }
    if (!gender) {
      genderError = 'This field is required.';
      showGlobalError = true;
    }
    if (!isValidBirthDate(birthDateObj)) {
      birthDateError = 'Birth date must be in the MM/DD/YYYY format.';
      showGlobalError = true;
    } else if (getAge(`${birthDateObj.year}-${birthDateObj.month}-${birthDateObj.day}`) < 18) {
      birthDateError = 'Spouse age must be 18 years or older.';
      showGlobalError = true;
    }

    if (currentSalary === '' || !isWithinAllowedRange(getIntegerAmount(currentSalary), 0, 999999999)) {
      currentSalaryError = 'Salary must be $0 - $999,999,999.';
      showGlobalError = true;
    }
    if (spouseRetirementStartAge < 18) {
      spouseRetirementStartAgeError = 'Retirement age must be 18 or older.';
      showGlobalError = true;
    }

    const spouseCurrentAge = birthDateObj.year ? getCurrentYear() - birthDateObj.year : 0;
    const spouseRetEndAgeBasedOnPpt = retirementEndAge - (participantAge - spouseCurrentAge);

    if (spouseRetirementStartAge >= spouseRetirementEndAge || spouseRetirementStartAge >= spouseRetEndAgeBasedOnPpt) {
      spouseRetirementStartAgeError =
        'Retirement age must be before ' +
        (spouseRetirementEndAge > spouseRetEndAgeBasedOnPpt ? spouseRetEndAgeBasedOnPpt : spouseRetirementEndAge) +
        '.\n';
      showGlobalError = true;
    }

    if (spouseRetirementStartAge > 85 && spouseCurrentAge) {
      if (spouseCurrentAge <= 85) {
        spouseRetirementStartAgeError = 'Retirement age must be 85 or younger.';
        showGlobalError = true;
      } else if (spouseCurrentAge > 85 && spouseRetirementStartAge > 114) {
        spouseRetirementStartAgeError = 'Retirement age must be 114 or younger.';
        showGlobalError = true;
      } else if (spouseCurrentAge > 85 && spouseRetirementStartAge !== spouseCurrentAge + 1) {
        spouseRetirementStartAgeError = 'Retirement age must be at least one year from now.';
        showGlobalError = true;
      }
    }

    updateSpouseError({
      showGlobalError,
      firstNameError,
      lastNameError,
      genderError,
      birthDateError,
      currentSalaryError,
      spouseRetirementStartAgeError,
    });

    return !showGlobalError;
  };

  buildPostObject = (scenario: any) => {
    const {
      spouse: {
        updatedFields,
        tempScenario: { spouseHasCompensation, spouseCompensationId },
      },
    } = this.props;
    let postObj: any = {};
    Object.keys(updatedFields).forEach(field => {
      switch (field) {
        case 'spouseRetirementStartAge':
          postObj = {
            ...postObj,
            spouseRetirementStartAge: Number(scenario.spouseRetirementStartAge),
          };
          break;
        case 'spouseSocialSecurityStartAge':
          postObj = {
            ...postObj,
            spouseSocialSecurityStartAge: scenario.spouseSocialSecurityStartAge,
          };
          break;
        case 'currentSalary':
          postObj = {
            ...postObj,
            compensations: [
              {
                amount: getIntegerAmount(scenario.currentSalary),
                bpId: scenario.bpId,
                action: spouseHasCompensation ? postActions.UPDATE : postActions.ADD,
                compensationType: 'ASLRY',
                id: spouseCompensationId,
                source: 'Spouse',
              },
            ],
          };
          break;
        case 'birthDateObj':
          postObj = {
            ...postObj,
            spouseProfile: {
              ...postObj.spouseProfile,
              birthDate: getDateString(scenario.birthDateObj),
            },
          };
          break;
        default:
          postObj = {
            ...postObj,
            spouseProfile: {
              ...postObj.spouseProfile,
              [field]: scenario[field],
              bpId: scenario.bpId,
            },
          };
          break;
      }
    });

    return postObj;
  };

  handleCancel = () => {
    const {
      updateSpouseData,
      updateSpouseError,
      hideModal,
      spouse: { modelledScenario },
    } = this.props;
    updateSpouseData(modelledScenario);
    updateSpouseError({
      showGlobalError: '',
      firstNameError: '',
      lastNameError: '',
      genderError: '',
      birthDateError: '',
      currentSalaryError: '',
      spouseRetirementStartAgeError: '',
    });
    hideModal();
  };

  showYourAccountsModal = () => {
    const { showModal, setCurrentView } = this.props;
    showModal(modals.ACCOUNT);
    setCurrentView(accountModalViews.YOUR_ACCOUNTS);
  };

  handleSaveAndAddEditAccounts = () => {
    const {
      modelSpouseData,
      postSimulation,
      spouse: { tempScenario },
    } = this.props;
    if (this.isDataValid()) {
      const postObj = this.buildPostObject(tempScenario);
      if (Object.keys(postObj).length !== 0) {
        postSimulation(postObj);
      }
      modelSpouseData();
      this.showYourAccountsModal();
    }
  };

  handleSave = () => {
    const {
      modelSpouseData,
      hideModal,
      postSimulation,
      spouse: { tempScenario },
    } = this.props;
    if (this.isDataValid()) {
      const postObj = this.buildPostObject(tempScenario);
      if (Object.keys(postObj).length !== 0) {
        postSimulation(postObj);
      }
      modelSpouseData();
      hideModal();
    }
  };

  render(): JSX.Element {
    const {
      tempScenario: {
        firstName,
        lastName,
        gender,
        currentSalary,
        spouseRetirementStartAge,
        spouseSocialSecurityStartAge,
        birthDateObj = {
          month: '',
          day: '',
          year: '',
        },
        bpId,
      },
      error: {
        showGlobalError,
        firstNameError,
        lastNameError,
        showGenderMessage,
        genderError,
        birthDateError,
        currentSalaryError,
        spouseRetirementStartAgeError,
      },
    } = this.props.spouse;
    const { isLoading } = this.props;

    const mq = window.matchMedia('(max-width: 767px)');
    return (
      <React.Fragment>
        <ReactModalHeader
          modalTitle="Spouse Profile"
          showClose={true}
          errorMessage={showGlobalError && 'There seem to be one or more errors. Please check your information.'}
          handleCloseIconClick={this.handleCancel}
        />
        <ReactModalContent showGlobalError={showGlobalError}>
          {!bpId && (
            <StyledIntroLine tabIndex={0}>
              Once you add a spouse, this information will be included in your retirement savings balances and
              projections throughout the site. Please review your information regularly to make sure it’s up to date.
            </StyledIntroLine>
          )}
          {bpId && (
            <StyledIntroLine tabIndex={0}>
              This information is included in your retirement savings balances and projections throughout the site. Make
              sure it’s up to date.
            </StyledIntroLine>
          )}
          <StyledText tabIndex={0}>All fields are required.</StyledText>
          <StyledFieldContainer>
            <StyledInputLabel>Spouse Name</StyledInputLabel>
            <Input
              name="firstName"
              value={firstName}
              placeholder="First Name"
              onChange={this.handleNameChange}
              autoComplete="off"
              aria-label="First Name"
              width={mq.matches ? '100%' : 166}
              errorMessage={firstNameError}
              maxLength={12}
              className="blocked_data"
            />
            <Input
              name="lastName"
              value={lastName}
              placeholder="Last Name"
              onChange={this.handleNameChange}
              autoComplete="off"
              aria-label="Last Name"
              width={mq.matches ? '100%' : 166}
              errorMessage={lastNameError}
              marginLeftPx={mq.matches ? 0 : 16}
              maxLength={12}
              className="blocked_data"
            />
          </StyledFieldContainer>
          <StyledFieldContainer>
            <StyledInputLabel>Birth Date</StyledInputLabel>
            <StyledInputErrorContainer>
              <DateComponent
                name="birthDateObj"
                value={birthDateObj}
                onChange={this.handleDateChange}
                aria-label="birthDate"
                hasError={birthDateError}
                className="blocked_data"
              />
              {birthDateError && <StyledError>{birthDateError}</StyledError>}
            </StyledInputErrorContainer>
          </StyledFieldContainer>
          <StyledFieldContainer>
            <StyledInputLabel>Male/Female</StyledInputLabel>
            <StyledInputErrorContainer>
              <Dropdown
                label="Select"
                options={Object.keys(genderOptions).map((key: string) => ({ name: genderOptions[key], value: key }))}
                onChange={(option: any) => this.handleGenderOptionChange(option)}
                selectedOption={
                  gender ? { name: genderOptions[gender], value: gender } : { name: 'Select', value: 'select' }
                }
                name="maleOrFemale"
                width={mq.matches ? '100%' : 192}
                errorMessage={genderError}
                className="blocked_data"
              />
              {showGenderMessage && (
                <StyledDropdownMessage>Your estimates and projections may be more conservative.</StyledDropdownMessage>
              )}
            </StyledInputErrorContainer>
          </StyledFieldContainer>
          <StyledFieldContainer>
            <StyledInputLabel>Current Salary</StyledInputLabel>
            <StyledInputErrorContainer>
              <Input
                name="currentSalary"
                value={
                  currentSalary !== '' && currentSalary >= 0 ? formatAmountWithoutDollarAndDecimals(currentSalary) : ''
                }
                placeholder="Amount"
                leadingCharacter="$"
                trailingCharacter="/yr."
                onChange={this.handleSalaryChange}
                autoComplete="off"
                aria-label="currentSalary"
                hasError={currentSalaryError}
                textAlign="right"
                width={mq.matches ? '100%' : 192}
                className="blocked_data"
              />
              {currentSalaryError && <StyledError>{currentSalaryError}</StyledError>}
              <StyledDropdownMessage>This will be incorporated into your income goal.</StyledDropdownMessage>
            </StyledInputErrorContainer>
          </StyledFieldContainer>
          <StyledFieldContainer>
            <StyledInputLabel>Retirement Age</StyledInputLabel>
            <StyledInputErrorContainer>
              <Input
                name="spouseRetirementStartAge"
                value={spouseRetirementStartAge}
                placeholder="Age"
                onChange={this.handleRetirementAgeChange}
                autoComplete="off"
                aria-label="Retirement Age"
                width={mq.matches ? '100%' : 60}
                hasError={spouseRetirementStartAgeError}
                maxLength={3}
              />
              {spouseRetirementStartAgeError && <StyledError>{spouseRetirementStartAgeError}</StyledError>}
            </StyledInputErrorContainer>
          </StyledFieldContainer>
          <StyledFieldContainer style={{ marginBottom: 56 }}>
            <StyledInputLabel>Social Security Age</StyledInputLabel>
            <StyledSocialSecurity>
              <IncrementDecrement
                value={spouseSocialSecurityStartAge}
                helperText="Try Age 70"
                minValue={spouseSocialSecurityStartAge < 62 ? spouseSocialSecurityStartAge : 62}
                maxValue={spouseSocialSecurityStartAge > 70 ? spouseSocialSecurityStartAge : 70}
                onPlusClick={this.incrementSocialSecurityAge}
                onMinusClick={this.decrementSocialSecurityAge}
              />
            </StyledSocialSecurity>
          </StyledFieldContainer>
        </ReactModalContent>
        <ReactModalFooter
          CTAButtonText="Save"
          handleCTAClick={this.handleSave}
          handleCancelClick={this.handleCancel}
          disabled={isInternal() || isLoading}
          CTAButtonId={analyticsTracking.RIXSpouseProfileSave}
          CancelButtonId={analyticsTracking.RIXSpouseProfileCancel}
        >
          <Button
            type="secondary"
            title="Save and Add/Edit Accounts"
            fitContainerWidth={mq.matches ? true : false}
            marginRightPx={mq.matches ? 0 : 16}
            onClick={this.handleSaveAndAddEditAccounts}
            tabIndex={0}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.handleSaveAndAddEditAccounts)}
            disabled={isInternal() || isLoading}
            id={analyticsTracking.RIXSpouseProfileSaveAddAccounts}
          />
        </ReactModalFooter>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  const { spouse, riScenario, charts } = state;
  return {
    spouse,
    isLoading: riScenario.loading || charts.loading,
    participantAge: getParticipantAge(state),
  };
};

export default connect(mapStateToProps, {
  showModal: modalActions.showModal,
  hideModal: modalActions.hideModal,
  setCurrentView: accountActions.setCurrentView,
  updateSpouseData: spouseActions.updateSpouseData,
  updateSpouseError: spouseActions.updateSpouseError,
  modelSpouseData: spouseActions.modelSpouseData,
  postSimulation: chartsActions.postSimulation,
})(AddSpouseProfile);
